export default __webpack_public_path__ + "static/media/JerriLovelace.9378df3c.png";